import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { useNavigate } from "react-router-dom";

const links = [
  { to: "/", label: "Home" },
  { to: "/profile", label: "Profile" },
  { to: "/babble", label: "Babble" },
  { to: "/leopardy/games", label: "Leopardy" },
  { to: "/wademon", label: "Wademon" },
  { to: "/nanoking", label: "NaNo" },
  { to: "/christmas-counter", label: "Christmas Counter" },
  { to: "/food-pairing", label: "Food Pairing" },
  { to: "/binaural-beats", label: "Binaural" },
  { to: "/lifelapse", label: "Lifelapse" },
  { to: "/oddventure", label: "Chadventure" },
  { to: "/graph", label: "Graph" },
  { to: "/docs", label: "Docs" },
  { to: "/srs", label: "Janki" },
];

export default function Toolbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, login, logout } = useAuth();
  const authed = !!user && !user.isAnonymous;
  const providerEmails = (user?.providerData || [])
    .map((p) => p.email)
    .filter(Boolean)
    .map((e) => e.toLowerCase());
  const effectiveEmail = (user?.email || providerEmails[0] || "").toLowerCase();
  const canSeeCortisolace = effectiveEmail === "dunderjeep@gmail.com" || user?.uid === "VvBUVY6rN5Xg358oNXW2eoUzQX92";
  const initial = (user?.displayName || user?.email || "").trim().charAt(0).toUpperCase() || "D";
  const avatarUrl = user?.photoURL;

  const handleLogin = async () => {
    try {
      await login();
      navigate("/profile");
    } catch (err) {
      console.error("Login failed", err);
      alert(`Login failed: ${err.message || err.toString()}`);
    }
  };

  return (
    <div style={{
      position: "sticky",
      top: 0,
      zIndex: 1000,
      background: "rgba(0, 0, 0, 0.75)",
      color: "#fff",
      padding: "10px 16px",
      boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
      backdropFilter: "blur(8px)",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "nowrap",
      gap: 16,
    }}>
      <div style={{ fontWeight: 700, letterSpacing: 0.5 }}>
        <Link to="/" style={{ color: "#fff", textDecoration: "none" }}>DunderJeep</Link>
      </div>
      <nav style={{ display: "flex", gap: 12, flexWrap: "nowrap", flex: "1 1 auto", justifyContent: "center", minWidth: 0, overflowX: "auto", whiteSpace: "nowrap" }}>
        {links.map(link => (
          <Link
            key={link.to}
            to={link.to}
            style={{
              color: location.pathname === link.to ? "#ffeb3b" : "#fff",
              textDecoration: "none",
              fontWeight: location.pathname === link.to ? 700 : 500
            }}
          >
            {link.label}
          </Link>
        ))}
        {canSeeCortisolace && (
          <Link
            to="/cortisolace"
            style={{
              color: location.pathname === "/cortisolace" ? "#ffeb3b" : "#fff",
              textDecoration: "none",
              fontWeight: location.pathname === "/cortisolace" ? 700 : 500
            }}
          >
            Cortisolace
          </Link>
        )}
      </nav>
      <div style={{ marginLeft: "auto" }}>
        {authed ? (
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <Link
              to="/profile"
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: 34,
                height: 34,
                borderRadius: "50%",
                background: "#ffeb3b",
                color: "#000",
                textDecoration: "none",
                fontWeight: 700,
                boxShadow: "0 1px 3px rgba(0,0,0,0.35)",
                overflow: "hidden",
              }}
              title="Profile"
            >
              {avatarUrl ? (
                <img src={avatarUrl} alt="avatar" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
              ) : (
                initial
              )}
            </Link>
            <button onClick={logout} style={{ background: "transparent", border: "1px solid #ffeb3b", color: "#ffeb3b", padding: "6px 10px", borderRadius: 6, cursor: "pointer" }}>
              Sign out
            </button>
          </div>
        ) : (
          <button onClick={handleLogin} style={{ background: "#ffeb3b", border: "none", padding: "6px 12px", borderRadius: 6, cursor: "pointer" }}>
            Sign in
          </button>
        )}
      </div>
    </div>
  );
}
